import {
  ConnectionOptions,
  createConnection,
  ConnectionManager,
  getConnectionManager,
  Connection,
  EntitySchema,
  EntityMetadata
} from 'typeorm'

/**
 * Database manager class
 * https://medium.com/safara-engineering/wiring-up-typeorm-with-serverless-5cc29a18824f
 */
export class Database {
  private connectionManager: ConnectionManager
  private readonly opts: ConnectionOptions

  constructor(opts: ConnectionOptions) {
    this.connectionManager = getConnectionManager()
    this.opts = opts
  }

  public async getConnection(): Promise<Connection> {
    const CONNECTION_NAME = `default`

    let connection: Connection

    if (this.connectionManager.has(CONNECTION_NAME)) {
      // console.info(`Database.getConnection()-using existing connection ...`);
      connection = this.connectionManager.get(CONNECTION_NAME)

      if (!connection.isConnected) {
        connection = await connection.connect()
      }
    } else {
      // console.info(`Database.getConnection()-creating connection ...`);
      connection = await createConnection(this.opts)

      // serverless-offline 사용하면 db 연결 재사용시 객체를 못찾는다
      // "name": "EntityMetadataNotFound",
      // "message": "No metadata for \"FriendEntity\" was found.",
      // connection.findMetadata 구현을 손봐서 우회
      const obj = connection as any
      const findMetadata = obj.findMetadata.bind(connection)
      obj.findMetadata = (target: EntitySchema<any> | string): EntityMetadata | undefined => {
        const output = findMetadata(target)
        if (output) {
          return output
        }

        return connection.entityMetadatas.find(metadata => {
          return metadata.target.toString() === target.toString()
        })
      }
    }

    return connection
  }
}
